import { render, staticRenderFns } from "./Leadership.vue?vue&type=template&id=2f974e98&scoped=true&"
import script from "./Leadership.vue?vue&type=script&lang=js&"
export * from "./Leadership.vue?vue&type=script&lang=js&"
import style0 from "./Leadership.vue?vue&type=style&index=0&id=2f974e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f974e98",
  null
  
)

export default component.exports